<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('personal.selectShippingAddress')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" class="text-blue" @click="addressListFlag = true">
        {{ $t("personal.management") }}
      </span>
    </van-nav-bar>
    <div class="search-wrap">
      <div class="location text-blue">
        <van-icon name="location-o" />
        <span>{{
          loadFlag ? $t("life.locating") : location && location.city
        }}</span>
        <!-- <van-icon name="arrow-down" /> -->
      </div>
      <van-search
        v-model="searchVal"
        shape="round"
        :placeholder="$t('personal.enterShippingAddress')"
        @input="getGoogleAddress"
      />
    </div>
    <div class="scroll-wrapper">
      <scroll>
        <div class="address">
          <div class="title text-gray">
            {{ $t("personal.currentLocation") }}
          </div>
          <div class="cur-location">
            <p>
              {{
                location.address === ""
                  ? $t("life.locating")
                  : location.address === "error"
                  ? $t("life.locatingFailed")
                  : location.city
              }}
            </p>
            <span class="text-blue location" @click="geolocation">
              <i class="icon-location"></i>
              {{ $t("personal.reLocate") }}
            </span>
          </div>
          <div class="title text-gray">
            {{ $t("personal.myShippingAddress") }}
          </div>
          <template></template>
          <div class="item" v-if="!address.length"></div>
          <div
            class="item"
            v-for="(item, index) in address"
            :key="index"
            @click="clickAddress(item)"
          >
            <div class="info">
              <h3>{{ item.address }}</h3>
              <p>{{ item.house_number }}</p>
              <p>
                {{ item.name }}({{
                  item.sex == 1
                    ? $t("common.Mr")
                    : item.sex == 2
                    ? $t("common.Ms")
                    : ""
                }})
                <span class="phone">{{ _phoneFormat(item.mobile) }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="near_address">
          <div class="title text-gray">{{ $t("personal.nearbyAddress") }}</div>
          <div
            class="item"
            v-for="(item, index) in addressList"
            :key="index"
            @click="addressGetLatlng(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </scroll>
    </div>
    <div class="button-wrap button-fixed">
      <van-button block type="primary" @click="addressFlag = true">
        {{ $t("personal.newAddress") }}
      </van-button>
    </div>
    <!-- 地址列表 -->
    <transition name="slide">
      <address-list
        v-if="addressListFlag"
        :addressListFlag.sync="addressListFlag"
        @getAddressList="getAddressList"
      />
    </transition>
    <!-- 添加地址 -->
    <transition name="slide">
      <address-manage
        v-if="addressFlag"
        :addressFlag.sync="addressFlag"
        @getAddressList="getAddressList"
      />
    </transition>
    <loading v-if="loadFlag" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddressList from "@/views/personal/address";
import AddressManage from "@/views/personal/address/address";
import Loading from "@/components/common/loading";
export default {
  meta: {
    power: false
  },
  components: {
    AddressList,
    AddressManage,
    Loading
  },
  data() {
    return {
      loadFlag: false,
      searchVal: "",
      city: this.$t("life.locating"),
      address: [],
      addressList: [],
      addressListFlag: false, // 地址列表Flag
      addressFlag: false // 添加地址Flag
    };
  },
  created() {
    this.getAddressList();

  },
  mounted() {},
  computed: {
    ...mapGetters(["location", "language"])
  },
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:locationFlag", false);
    },
    getAddressList() {
      // 获取地址列表
      let vm = this;
      vm.$post("/app/user/address", {}, { loading: true }).then(res => {
        console.log("address", res);
        vm.address = res.data;
      });
    },
    geolocation() {
      debugger
      // 定位
      let vm = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            // 获取地理位置成功
            console.log("经度:" + position.coords.longitude);
            console.log("纬度:" + position.coords.latitude);
            console.log("准确度:" + position.coords.accuracy);
            console.log("海拔:" + position.coords.altitude);
            console.log("海拔准确度:" + position.coords.altitudeAcuracy);
            console.log("行进方向:" + position.coords.heading);
            console.log("地面速度:" + position.coords.speed);
            console.log("请求的时间:" + new Date(position.timestamp));
            let params = {};
            params.language = vm.language == "en" ? "en_US" : "zh_CN";
            params.latlng =
              position.coords.latitude + "," + position.coords.longitude;
            params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
            console.log("getLocation.params", params);
            vm.loadFlag = true;
            vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params)
              .then(res => {
                vm.loadFlag = false;
                console.log("getLocation.res", res);
                if (res.status == "OK") {
                  vm.$store.dispatch("SET_LOCATION", res.results);
                  vm.centers = res.results[0].geometry.location;
                  vm.markers = [];
                  let position = {};
                  position.lat = vm.centers.lat;
                  position.lng = vm.centers.lng;
                  vm.markers.push({ position });
                  vm.curAddress = res.results[0].formatted_address;
                  vm.getGoogleAddress(vm.curAddress);
                } else {
                  vm.$toast("定位失败");
                }
              })
              .catch(error => {
                vm.loadFlag = false;
                console.log("catch.error", error);
              });
          },
          function(error) {
            // 获取地理位置失败
            console.log("function.error", error);
            vm.loadFlag = false;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                vm.$toast("定位失败,用户拒绝请求地理定位");
                break;
              case error.POSITION_UNAVAILABLE:
                vm.$toast("定位失败,位置信息是不可用");
                break;
              case error.TIMEOUT:
                vm.$toast("定位失败,请求获取用户位置超时");
                break;
              case error.UNKNOWN_ERROR:
                vm.$toast("定位失败,定位系统失效");
                break;
            }
          },
          {
            // 指示浏览器获取高精度的位置，默认为false
            enableHighAccuracy: true,
            // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
            timeout: 5000,
            // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
            maximumAge: 3000
          }
        );
      } else {
        vm.$toast("Your browser does not support Geolocation!");
      }
    },
    clickAddress(data) {
      // 点击地址
      console.log("clickAddress", data);
      let latlng = {};
      latlng.lat = Number(data.latitude);
      latlng.lng = Number(data.longitude);
      this.latlngGetAddress(latlng);
    },
    addressGetLatlng(data) {
      // 根据地址获取坐标
      console.log("addressGetLatlng.data", data);
      let vm = this;
      let params = {};
      params.language = vm.language == "en" ? "en_US" : "zh_CN";
      params.place_id = data.place_id;
      params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
      vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params).then(
        res => {
          console.log("addressGetLatlng", res);
          if (res.status == "OK") {
            this.$store.dispatch("SET_LOCATION", res.results);
            let latlng = res.results[0].geometry.location;
            vm.latlngGetAddress(latlng);
            console.log("latlng", latlng);
          }
        }
      );
    },
    latlngGetAddress(latlng) {
      // 根据坐标获取地址
      let vm = this;
      let params = {};
      params.language = vm.language == "en" ? "en_US" : "zh_CN";
      params.latlng = latlng.lat + "," + latlng.lng;
      params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
      vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params).then(
        res => {
          console.log("latlngGetAddress", res);
          if (res.status == "OK") {
            this.$store.dispatch("SET_LOCATION", res.results);
            this.$emit("update:locationFlag", false);
            this.$emit("nearbyStore");
          }
        }
      );
    },
    getGoogleAddress(value) {
      // 搜索谷歌地图
      let vm = this;
      let params = {};
      params.title = value;
      vm.addressList = [];
      vm.$post("/app/help/getGoogleAddress", params, { alert: true }).then(
        res => {
          console.log("getGoogleAddress", res);
          vm.addressList = res.data;
        }
      );
    }
  },
  watch: {
    location: {
      handler(obj) {
        if (obj && obj.latitude) {
          this.getGoogleAddress(obj.address);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.search-wrap {
  top: 44px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  background: #fff;
  .location {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90px;
    font-size: 14px;
    overflow: hidden;
    .van-icon {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .van-search {
    flex: 1;
    margin-left: 5px;
    padding: 0;
    .van-cell {
      padding: 3px 8px 3px 0;
    }
    .van-search__content {
      background: #f0f0f0;
    }
    /deep/.van-icon-search {
      color: #bcbcbc;
    }
  }
}
.scroll-wrapper {
  top: 92px;
  bottom: 65px;
}
.title {
  line-height: 1.2;
}

.address {
  padding: 0 15px;
  .cur-location {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px 0;
    border-bottom: 1.1px solid #e9e9e9;
    p {
      flex: 1;
      font-size: 14px;
    }
    .location {
      margin-left: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-location {
        margin-right: 2px;
        width: 16px;
        height: 16px;
        background: url("@{images}public/location@2x.png");
        background-size: 100%;
      }
    }
  }
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    line-height: 1.2;
    border-bottom: 1.1px solid #e9e9e9;
    &:last-child {
      border-bottom: 0;
    }
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
      p {
        margin-top: 5px;
        color: #666;
      }
    }
    .icon-edit {
      width: 20px;
      height: 20px;
      background: url("@{images}public/icon_edit@2x.png") no-repeat;
      background-size: 100%;
    }
  }
}

.near_address {
  padding: 10px 15px;
  border-top: 10px solid #f4f4f4;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    font-size: 14px;
    line-height: 1.2;
    border-bottom: 1.1px solid #e9e9e9;
  }
}
</style>
